import { YAGA_EXTERNALS } from 'config/fe-routes';
import { useTranslation } from 'react-i18next';

import A from '../Link/Link';

const SideMenuPrivacyLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
  return (
    <A className="no-style" target="_blank" rel="noopener noreferrer" href={href}>
      {children}
    </A>
  );
};

const SideMenuPrivacyLinks: React.FC = () => {
  const { t } = useTranslation();

  const showCookieBanner = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (window.Cookiebot && typeof window.Cookiebot.show === 'function') {
      window.Cookiebot.show();
    }
  };

  return (
    <div className="privacy-component__content">
      <SideMenuPrivacyLink href={YAGA_EXTERNALS.TERMS().href}>{t('sidemenu.terms-conditions')}</SideMenuPrivacyLink>
      <SideMenuPrivacyLink href={YAGA_EXTERNALS.PRIVACY_POLICY().href}>{t('sidemenu.privacy-policy')}</SideMenuPrivacyLink>
      <A className="no-style" onClick={showCookieBanner} href="">
        {t('sidemenu.cookie')}
      </A>
    </div>
  );
};

export default SideMenuPrivacyLinks;
